import { StyledModal } from '@app/components/modal/Modal';
import useAgentActions from '@app/hooks/agents/useAgentActions';
import type { AINumber } from '@app/services/number.types';
import type { ModalProps } from 'antd';
import { AssignAiAgentForm, type AssignAiFormValues } from './AssignAiAgentForm';

export type AssignAiAgentModalProps = ModalProps & {
    title?: string;
    data?: AINumber;
    onCancel?: () => void;
};

export const AssignAiAgentModal = ({
    title = 'Assign AI Agent',
    onOk,
    ...props
}: AssignAiAgentModalProps) => {
    const { assignNumber } = useAgentActions();

    const handleSubmit = (values: AssignAiFormValues) => {
        assignNumber.mutate(
            {
                agent_id: values.agent_id,
                location_id: values.location_id,
                number_id: values.number_id,
                failover_number: values.failover_number,
            },
            {
                onSuccess: () => {
                    if (onOk) {
                        onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                    }
                },
            }
        );
    };

    // Reset the component if closed
    if (!props.open) {
        return null;
    }

    return (
        <StyledModal title={title} footer={null} width={680} {...props}>
            <AssignAiAgentForm
                id="ai-numbers-add"
                onCancel={props.onCancel}
                loading={assignNumber.isPending}
                onSubmit={handleSubmit}
                data={props.data}
            />
        </StyledModal>
    );
};
